import { useLocation } from "react-router-dom";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import LinkButton from "components/ui/LinkButton";

type GenericErrorType = {
    xRequestId: string;
    message: string;
};

function ErrorGeneric() {
    const location = useLocation();

    const stateToUse = location.state as GenericErrorType;

    return (
        <GridColumn>
            <GridItem>
                <GridRow justifyContent={"center"}>
                    <GridItem className={"col-xs-auto"} style={{ textAlign: "center" }}>
                        <h1>Errore generico</h1>

                        {stateToUse.message ? <p>{stateToUse.message}</p> : null}
                        {stateToUse.xRequestId ? (
                            <p>
                                {`Identificativo errore per assistenza: ${stateToUse.xRequestId}`}
                            </p>
                        ) : null}
                    </GridItem>
                </GridRow>

                <GridRow justifyContent={"center"}>
                    <GridItem className={"col-xs-auto"}>
                        <LinkButton
                            variant={"contained"}
                            to={"/dashboard"}
                            label={"Ritorna alla dashboard"}
                        />
                    </GridItem>
                </GridRow>
            </GridItem>
        </GridColumn>
    );
}

export default ErrorGeneric;
